import React from 'react'
import { Formik, Form } from 'formik'
import { InputField, LoaderButton } from 'components/molecules'
import CurrencyInputField from 'components/molecules/currency-input-field'
import revenueTransferScheme from './revenue-transfer-scheme'
import PropTypes from 'prop-types'

const propTypes = {
  revenue: PropTypes.shape({
    transferred_amount : PropTypes.string,
    seller             : PropTypes.shape({
      bank           : PropTypes.string,
      bank_branch    : PropTypes.string,
      account_number : PropTypes.string
    })
  }),
  handleSubmitForm: PropTypes.func
}

const defaultProps = {
  revenue: {
    transferred_amount : '',
    seller             : {
      bank           : '',
      bank_branch    : '',
      account_number : ''
    }
  },
  handleSubmitForm: () => {}
}

const RevenueTransferForm = ({
  revenue,
  handleSubmitForm
}) => (
  <Formik
    enableReinitialize={ true }
    initialValues={{
      amount                        : revenue?.transferred_amount || '',
      receiving_bank                : revenue?.seller?.bank || '',
      receiving_bank_account_name   : revenue?.seller?.bank_branch || '',
      receiving_bank_account_number : revenue?.seller?.account_number ||'',
      notes                         : ''
    }}
    validationSchema={ revenueTransferScheme }
    onSubmit={ handleSubmitForm }
  >
    {
      (formik) => (
        <Form>
          <CurrencyInputField
            type='text'
            name='amount'
            label='Transfer Amount'
            required={ true }
          />
          <InputField
            type='text'
            name='receiving_bank'
            label='Receiving Bank'
            required={ true }
          />
          <InputField
            type='text'
            name='receiving_bank_account_name'
            label='Receiving Bank Account Name'
            required={ true }
          />
          <InputField
            type='number'
            name='receiving_bank_account_number'
            label='Receiving Bank Account Number'
            required={ true }
          />
          <InputField
            type='text'
            name='notes'
            label='Notes'
            required={ true }
          />
          <LoaderButton
            className='w-100'
            type='submit'
            color='success'
            disabled={ formik.isSubmitting }
          >
            { 'Transfer' }
          </LoaderButton>
        </Form>
      )
    }
  </Formik>
)

RevenueTransferForm.propTypes    = propTypes
RevenueTransferForm.defaultProps = defaultProps

export default RevenueTransferForm
